import { apiRequest } from './client';

export function fetchInventory(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/admin/inventory${query ? `?${query}` : ''}`, token);
}

export function createInventoryItem(token, data) {
  return apiRequest('/admin/inventory', token, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function updateInventoryItem(token, data) {
  return apiRequest('/admin/inventory', token, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export function deleteInventoryItem(token, id) {
  return apiRequest(`/admin/inventory?id=${id}`, token, { method: 'DELETE' });
}

export function passInventoryQc(token, id, quantity) {
  return apiRequest(`/admin/inventory/${id}/pass-qc`, token, {
    method: 'POST',
    body: JSON.stringify(
      quantity == null ? {} : { quantity: Number(quantity) }
    ),
  });
}
